import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { addPageData, navigateWizard } from '../../actions';
import QuestionPageLayout from '../../components/QuestionPageLayout';
import analytics from '../../lib/analytics';
import * as payloadFactory from '../../lib/pageDataPayloadFactory';
import { hasConfirmedJobOfferSelector } from '../../reducers/selectors';

export const ConfirmedJobOfferPage = ({
  initialConfirmedJobOffer,
  dispatchAddPageData,
  dispatchWizardNav,
}) => {
  const handleSubmit = hasConfirmedJobOffer => {
    analytics.sendEvent('Click - Next', 'confirmed-job-offer');

    const payload = payloadFactory.createAddPageDataPayload(
      'hasConfirmedJobOffer',
      hasConfirmedJobOffer,
    );
    dispatchAddPageData(payload);
    dispatchWizardNav({ dir: 'fwd', resetState: true });
  };

  const helpText =
    "You'll need to provide us with the signed job offer letter or employment contract, when we verify your documents. You don't have to tell us about job offers that you do not plan to accept.";

  return (
    <QuestionPageLayout
      id="job-offer"
      value={initialConfirmedJobOffer}
      title="Have you accepted a job offer that you plan to start after graduation?"
      onSubmit={handleSubmit}
      helpText={helpText}
    />
  );
};

ConfirmedJobOfferPage.propTypes = {
  initialConfirmedJobOffer: PropTypes.bool,
  dispatchAddPageData: PropTypes.func.isRequired,
  dispatchWizardNav: PropTypes.func.isRequired,
};

ConfirmedJobOfferPage.defaultProps = {
  initialConfirmedJobOffer: null,
};

export const mapStateToProps = state => ({
  initialConfirmedJobOffer: hasConfirmedJobOfferSelector(state),
});

export const mapDispatchToProps = {
  dispatchAddPageData: addPageData,
  dispatchWizardNav: navigateWizard,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmedJobOfferPage);
